import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';
import { PhoneNumberInput } from '@dreryk/react-components';

import { prescriptionsTranslationKeys } from '../../../../../../../../translations';

import { ProAuctoreAndProFamiliaPhoneNumberSectionFormBeanPart } from './PhoneNumberSection.types';

type PhoneNumberSectionProps = {
   readonly register: BindingCreator<ProAuctoreAndProFamiliaPhoneNumberSectionFormBeanPart>;
};

export const PhoneNumberSection = (props: PhoneNumberSectionProps): ReactElement => {
   return (
      <PhoneNumberInput
         testId={'phoneNumber'}
         controller={props.register('phoneNumber', { required: true })}
         label={prescriptionsTranslationKeys.missingAddressForPAPF.yourPhoneNumber}
      />
   );
};
